import React, { Component } from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'

class ResumeCart extends Component {
  constructor (props) {
    super(props)

    this.state = {
      termAccepted: false
    }
  }

  acceptTermsEvent = () => {
    if (!this.state.acceptTerms) {
      this.setState({
        acceptTerms: true
      })
    } else {
      this.setState({
        acceptTerms: false
      })
    }
  }

  render () {
    return (
      <div className='col-12 col-md-4'>
        <div className='cart-side border-ui-3 radius bg-white px-0 py-0 mt-3 mt-md-0'>
          <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
            <h2 className='color-title txt-font-body'>Resumo da compra</h2>
          </div>
          <div className='cart-subtotal col-12 pb-3 mx-0'>
            <div className='row product-brand pt-2 pb-2  px-2  border-dotted-bottom border-color-ui-3 bg-ui-4'>
              <div className='col-12 justify-content-center align-self-center'>
                <p className='txt-body-sm txt-font-body color-ui-2 txt-left'>
                  Transação: <strong>Compra de pontos</strong>
                </p>
                <p className='mt-half txt-body-sm txt-font-body color-ui-2 txt-left'>
                  Valor em pontos:{' '}
                  <strong>
                    {this.props.points.toLocaleString('pt-br', {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })}{' '}
                    pontos
                  </strong>
                </p>
                <p className='mt-half txt-body-sm txt-font-body color-ui-2 txt-left'>
                  Valor em reais:{' '}
                  <strong className='txt-initial'>
                    R${' '}
                    {this.props.cash.toLocaleString('pt-br', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </strong>
                </p>
              </div>
            </div>

            <div className='row pb-1 px-2'>
              <div className='col-12'>
                <div className='row mx-0 h-100 align-items-center' />
              </div>
            </div>

            <div className='cart-done row px-2'>
              <div className='col-12 justify-content-center align-self-center'>
                <Button
                  className='btn-featured btn-icon nowrap'
                  text='Finalizar pagamento'
                  disabled={!this.props.canCheckout()}
                  iconName='icon_gift'
                  onClick={this.props.purchasePointsFinaly}
                  loading={this.props.isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ResumeCart.propTypes = {
  points: PropTypes.string,
  cash: PropTypes.string,
  canCheckout: PropTypes.func,
  isLoading: PropTypes.bool,
  purchasePointsFinaly: PropTypes.func
}

export default ResumeCart



// WEBPACK FOOTER //
// ./src/Checkout/PointsPurchase/ResumeCart/ResumeCart.js